const ITEMS = [
  { icon: "fa-file-text-o",   title: "GST Registered",          desc: "Registered under Goods & Services Tax for transparent B2B transactions and invoicing across India." },
  { icon: "fa-building",      title: "MSME Registered",         desc: "Recognised under the Ministry of Micro, Small & Medium Enterprises — Udyam Registration." },
  { icon: "fa-certificate",   title: "BIS / ISI Compliance",    desc: "Products sourced and supplied in compliance with BIS / ISI standards — pressure cookers (IS 2347) and gas stoves." },
  { icon: "fa-leaf",          title: "Food Grade Standards",    desc: "All cookware products meet food-grade material standards — SS304, SS430, food-grade aluminium surfaces." },
  { icon: "fa-search",        title: "Quality Assurance",       desc: "Multi-stage quality checks on every batch — from sourcing and production to final packaging and dispatch." },
  { icon: "fa-shield",        title: "Documentation on Request",desc: "GST certificate, MSME registration and compliance documents available to verified B2B partners on request." },
];

export const Certifications = () => (
  <div id="certifications" className="certifications-section">
    <div className="container">
      <div className="section-title">
        <h2>Quality & Compliance</h2>
        <p>Every product we supply meets rigorous quality standards and regulatory compliance — verifiable on request.</p>
      </div>
      <div className="row">
        {ITEMS.map((c, i) => (
          <div key={i} className="col-md-4 col-sm-6">
            <div className="cert-card">
              <div className="cert-icon-wrap"><i className={`fa ${c.icon}`}></i></div>
              <h4>{c.title}</h4>
              <p>{c.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="cert-note">
        <i className="fa fa-info-circle"></i>
        Documentation available on request to verified dealers, distributors and B2B partners.
      </div>
    </div>
  </div>
);
